import ControlButtonStandard from "../../../../../core/gd-components/buttons/control-button/control-button-standard";
import React from "react";

type Props = {
    onNewPage: {():void}
}

export default function LeftControls(props:Props) {
    return (
        <div className="gd-draftail-toolbar-group">
            <ControlButtonStandard className    = "add-page-button m-r-10"
                                   iconClass    = "i5-add-page fs-16"
                                   hint         = "Add page"
                                   onClick      = {props.onNewPage}/>
        </div>
    )
}